// shop-side-menu.js
// Side Menu Functionality for Shop Navigation

(function () {
  'use strict';

  // Wait for DOM to be fully loaded
  function initSideMenu() {
    const shopTrigger = document.getElementById('shopMenuTrigger');
    const sideMenu = document.getElementById('shopSideMenu');
    const overlay = document.getElementById('shopSideMenuOverlay');
    const closeButton = document.getElementById('shopSideMenuClose');
    const body = document.body;

    // Check if elements exist
    if (!shopTrigger || !sideMenu || !overlay || !closeButton) {
      console.log('Shop side menu: Required elements not found');
      return;
    }

    console.log('Shop side menu: Initialized successfully');

    // Function to open menu
    function openSideMenu() {
      sideMenu.classList.add('active');
      overlay.classList.add('active');
      body.classList.add('side-menu-open');

      // Set focus to close button for accessibility
      setTimeout(() => {
        closeButton.focus();
      }, 300);
    }

    // Function to close menu
    function closeSideMenu() {
      sideMenu.classList.remove('active');
      overlay.classList.remove('active');
      body.classList.remove('side-menu-open');

      // Return focus to trigger
      shopTrigger.focus();
    }

    // Open menu when Shop is clicked
    shopTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('Shop clicked - opening menu');
      openSideMenu();
    });

    // Alternative: Find all shop links if you have multiple
    document.querySelectorAll('[data-shop-menu-trigger]').forEach(trigger => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openSideMenu();
      });
    });

    // Close menu when X is clicked
    closeButton.addEventListener('click', function () {
      console.log('Close button clicked');
      closeSideMenu();
    });

    // Close menu when overlay is clicked
    overlay.addEventListener('click', function () {
      console.log('Overlay clicked');
      closeSideMenu();
    });

    // Close menu with Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sideMenu.classList.contains('active')) {
        console.log('Escape key pressed');
        closeSideMenu();
      }
    });

    // Highlight current collection if on a collection page
    if (window.location.pathname.includes('/collections/')) {
      const currentPath = window.location.pathname;
      document.querySelectorAll('.shop-side-menu-link').forEach(link => {
        if (link.getAttribute('href') === currentPath) {
          link.classList.add('active');
        }
      });
    }

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // Close menu if screen becomes too small
        if (window.innerWidth <= 1024) {
          closeSideMenu();
        }
      }, 250);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSideMenu);
  } else {
    // DOM is already loaded
    initSideMenu();
  }

  // Also initialize when Shopify Ajax cart updates (for dynamic themes)
  document.addEventListener('cart:updated', initSideMenu);
  document.addEventListener('page:loaded', initSideMenu);

})();